import { lazy } from "react";
import { PageData } from "../type";

/** Main 페이지 데이터 */
const COMMON_PAGE_DATA = {
    Main: { path: '/main', title: '자료수집관리', component: lazy(() => import('@/pages/MenuPages/HomeMain')) },
} as const satisfies Record<string, PageData>

export default COMMON_PAGE_DATA;